import { IModalInstanceService } from "angular-ui-bootstrap";
import { WorkflowService } from "../service/WorkflowService";
import { WorkflowTaskService } from "./WorkflowTaskService";
import { IHttpService, IFormController, IComponentOptions, IOnDestroy, IOnInit, IScope } from "angular";
import { CurrentUserService } from "../../../../services/user/CurrentUserService";
import { WorkflowRecord } from "../models/WorkflowRecord";
import template from "./TaskDialog.html";
import { AccountId } from "../../../types/AccountRecord";
import { Observable, ReplaySubject } from "rxjs";
import { AccountStore } from "app/account/store/AccountStore";
import { ReadonlyAccountStore } from "app/account/store/ReadonlyAccountStore";
import { AccountSource } from "app/account/types/AccountSource";
import { AccountBriefRecord } from "app/account/types/AccountBriefRecord";
import { isNotNull } from "app/js/util/UtilFunctions";
import { Resolvable } from "@uirouter/angularjs";
import { DateTimeUtil } from "app/js/util/DateTimeUtil";
import moment from "moment";
import { IsoDateTime } from "app/pseudo-types/DateTypes";
import { string } from "prop-types";
import { WorkflowViewStore } from "../store/WorkflowViewStore"
import { WorkflowViewModel, WorkflowViewModels } from "..//models/WorkflowViewModel";
import { workflow } from "../WorkflowComponent";


export const WorkflowTask = "workflowTask";

export function workflowTask() {
  return {
    template,
    bindings: {
      modalInstance: "<",
      resolve: "<"
    },
    controllerAs: "ctrl",
    controller: TaskDialogController
  };
}

interface Resolve {
  readonly accountId: AccountId,
  readonly workflow?: WorkflowRecord,
  readonly _store: WorkflowViewStore
}

export class TaskDialogController implements IOnInit, IOnDestroy {


  public mode = "create";

  /** @input */
  public readonly resolve: Resolve;

  /** @input */
  public readonly modalInstance: IModalInstanceService;

  // private readonly store: WorkflowViewStore;

  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  public readonly models$: Observable<WorkflowViewModels>;

  public readonly accountSource: AccountSource;

  /** @ngInject */
  public constructor(private readonly $scope: IScope,
    private readonly workflowService: WorkflowService,
    private readonly workflowTaskService: WorkflowTaskService,
    private readonly $http: IHttpService,
    private readonly currentUserService: CurrentUserService,
    private readonly accountStore: AccountStore
  ) {
    this.accountSource = ReadonlyAccountStore.create(accountStore);
  }


  public async $onInit() {
    this.prefillTask(this.resolve.workflow ?? null);
    if (this.resolve.workflow == undefined) {
      this.isUpdate = false;
    } else {
      this.isUpdate = true;
    }

  }

  public $onDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }


  /** @ui-binding */
  public readonly workflowForm: IFormController;

  /** ngModel bindings */
  public name: string | null;
  public note: string | null;
  public status: string | null;
  public reminder: Date | null;
  public reminderRepeatUnit: string | null;
  public reminderRepeatValueDay: number;
  public reminderRepeatValueWeek: number;
  public reminderRepeatValueMonth: number;
  public dueDate: Date | null;
  public isUpdate: boolean;

  private workflowId: number;


  public async createTask() {
    const userId = this.currentUserService.userId;
    var repeatValue = this.getRepeatValue(this.reminderRepeatUnit);
    const postData = {
      tag: this.name,
      notes: this.note,
      status: this.status,
      reminderDate: this.reminder,
      dueDate: this.dueDate,
      reminderRepeatUnit: this.reminderRepeatUnit,
      reminderRepeatValue: repeatValue
    }
    if (this.isUpdate) {
      this.resolve._store.editNote(this.workflowId, postData);
    } else {
      this.resolve._store.addNote(postData);
    }
    this.modalInstance.close();

  }

  public reminderChangeDay(event: Event) {
    this.reminderRepeatUnit = 'DAY'
  }

  public reminderChangeWeek() {
    this.reminderRepeatUnit = 'WEEK'
  }

  public reminderChangeMonth() {
    this.reminderRepeatUnit = 'MONTH'
  }

  private prefillTask(workflowRecord: WorkflowRecord | null) {
    if (workflowRecord != undefined || workflowRecord != null) {
      this.workflowId = workflowRecord.id;
      this.name = workflowRecord.noteTag;
      this.note = workflowRecord.notes;
      this.status = workflowRecord.status;
      this.reminderRepeatUnit = workflowRecord.reminderRepeatUnit;
      this.dueDate = new Date(workflowRecord.dueDate);
      this.reminder = new Date(workflowRecord.reminderDate);
      this.setRepeatValue(workflowRecord.reminderRepeatUnit, workflowRecord.reminderRepeatValue)
    } else {
      this.reminderRepeatUnit = "NO_REPETITION";
    }
  }

  private setRepeatValue(repeatUnit: string, repeatValue: number) {
    switch (repeatUnit) {
      case "DAY":
        this.reminderRepeatValueDay = repeatValue;
        break;
      case "WEEK":
        this.reminderRepeatValueWeek = repeatValue;
        break;
      case "MONTH":
        this.reminderRepeatValueMonth = repeatValue;
        break;
    }
  }

  private getRepeatValue(repeatUnit: string | null): number {
    var reminderRepeatValue = 0;
    switch (repeatUnit) {
      case "DAY":
        reminderRepeatValue = this.reminderRepeatValueDay;
        break;
      case "WEEK":
        reminderRepeatValue = this.reminderRepeatValueWeek;
        break;
      case "MONTH":
        reminderRepeatValue = this.reminderRepeatValueMonth;
        break;
    }
    return reminderRepeatValue;

  }

  private async cancel() {
    this.modalInstance.dismiss();
  }

}
